import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { EventsCalendarPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

const calendarSearchSchema = z.object({
  view: z
    .enum(["dayGridMonth", "timeGridWeek", "timeGridDay"])
    .optional()
    .catch(undefined),
})

export const Route = createFileRoute(
  "/_authenticated/_organization/events/calendar"
)({
  component: () => (
    <AuthorizationGate resource={Resource.EVENT} action={Action.READ}>
      <EventsCalendarPage />
    </AuthorizationGate>
  ),
  validateSearch: calendarSearchSchema,
})
